import React, { Component } from "react";

import { FormattedMessage, useIntl } from "react-intl";
import Tutorial from "../../../../components/Tutorial";

import { IProps } from "./interfaces";
import messages from "./messages";

const PackTutorial = ({ close }: IProps) => {
    const { formatMessage } = useIntl();
    return (
        <Tutorial close={close} title={<FormattedMessage {...messages.title} />}>
            {[
                {
                    title: <FormattedMessage {...messages.title1} />,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: formatMessage({ ...messages.description1 }, {}),
                            }}
                        />
                    ),
                },
                {
                    title: <FormattedMessage {...messages.title2} />,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: formatMessage({ ...messages.description2 }, {}),
                            }}
                        />
                    ),
                },
                {
                    title: <FormattedMessage {...messages.title3} />,
                    content: (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: formatMessage({ ...messages.description3 }),
                            }}
                        />
                    ),
                },
            ]}
        </Tutorial>
    );
}

export default PackTutorial;
